import { Tree, TreeNode, TreeNodeData } from "@/types/tree";
import defensiveCopy from "@/util/defensive-copy";
import { _getNextNodeIdAndIncrementNextNodeId } from "./tree";

export function createNode(
  treeToMutate: Tree,
  nodeData: TreeNodeData,
  options?: {
    reuseId?: boolean;
    idToUse?: TreeNode["id"];
  }
) {
  const nodeId =
    options?.reuseId && options.idToUse
      ? options.idToUse
      : _getNextNodeIdAndIncrementNextNodeId(treeToMutate);

  const newNode: TreeNode = {
    id: nodeId,
    data: defensiveCopy(nodeData),
    children: []
  };

  treeToMutate._lookupTable[nodeId.toString()] = newNode;

  return newNode;
}
